import { render, staticRenderFns } from "./lista-de-telefonos.vue?vue&type=template&id=00e11008&"
import script from "./lista-de-telefonos.vue?vue&type=script&lang=ts&"
export * from "./lista-de-telefonos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports